import { render, staticRenderFns } from "./MidiaTextoVerticalFullscreen.vue?vue&type=template&id=68742899&scoped=true"
import script from "./MidiaTextoVerticalFullscreen.vue?vue&type=script&lang=js"
export * from "./MidiaTextoVerticalFullscreen.vue?vue&type=script&lang=js"
import style0 from "./MidiaTextoVerticalFullscreen.vue?vue&type=style&index=0&id=68742899&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68742899",
  null
  
)

export default component.exports